import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../../../api/axios";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import DataTable from "examples/Tables/DataTable";

export default function VariationBatches() {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [effectiveMonth, setEffectiveMonth] = useState(new Date().toISOString().slice(0, 7));
  const [title, setTitle] = useState("");

  const load = async () => {
    setLoading(true);

    try {
      const response = await axios.get("/variation-batches", {
        params: { per_page: 50 },
      });

      setRows(response?.data?.data || []);
    } catch (error) {
      console.error("Failed to load variation batches:", error);
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const createBatch = async () => {
    try {
      const response = await axios.post("/variation-batches", {
        effective_month: effectiveMonth,
        title,
      });

      const batch = response?.data?.data;

      alert("Batch created successfully.");
      setTitle("");
      await load();

      if (batch?.id) {
        navigate(`/variations/batches/${batch.id}`);
      }
    } catch (error) {
      console.error("Failed to create batch:", error);
      alert(error?.response?.data?.message || "Failed");
    }
  };

  const columns = useMemo(
    () => [
      { Header: "ID", accessor: "id" },
      { Header: "Ref", accessor: "batch_ref" },
      { Header: "Month", accessor: "effective_month" },
      { Header: "Status", accessor: "status" },
      { Header: "Valid", accessor: "valid_items" },
      { Header: "Invalid", accessor: "invalid_items" },
      { Header: "Total Items", accessor: "total_items" },
      {
        Header: "Open",
        accessor: "open",
        Cell: (cell) => {
          const batchId = cell?.row?.original?.id;

          return (
            <MDButton
              size="small"
              color="info"
              onClick={() => navigate(`/variations/batches/${batchId}`)}
              disabled={!batchId}
            >
              Open
            </MDButton>
          );
        },
      },
    ],
    [navigate]
  );

  return (
    <MDBox p={3}>
      <MDTypography variant="h5">Variations — Monthly Batch Upload</MDTypography>

      <MDTypography variant="button" color="text">
        Upload one Excel for the month. The system splits each row into multiple variation types per
        staff, validates, then routes for approval.
      </MDTypography>

      <MDBox mt={3} p={2} sx={{ border: "1px solid #eee", borderRadius: 2 }}>
        <MDTypography variant="h6">Create Batch</MDTypography>

        <MDBox mt={1} display="flex" gap={2} flexWrap="wrap" alignItems="center">
          <MDBox width={180}>
            <MDInput
              label="Effective Month (YYYY-MM)"
              value={effectiveMonth}
              onChange={(event) => setEffectiveMonth(event.target.value)}
            />
          </MDBox>

          <MDBox width={320}>
            <MDInput
              label="Title (optional)"
              value={title}
              onChange={(event) => setTitle(event.target.value)}
            />
          </MDBox>

          <MDButton color="info" onClick={createBatch} disabled={loading}>
            Create
          </MDButton>

          <MDButton color="secondary" onClick={load} disabled={loading}>
            Refresh
          </MDButton>
        </MDBox>
      </MDBox>

      <MDBox mt={3}>
        <DataTable
          table={{ columns, rows }}
          entriesPerPage={false}
          showTotalEntries={false}
          canSearch
          pagination
          noEndBorder
        />
      </MDBox>
    </MDBox>
  );
}
